module.exports = __webpack_public_path__ + "static/media/path4.375d455d.svg";